import { WebinarSession } from './WebinarSessionsList'

export function formatDateTime(isoString: string): string {
  const date = new Date(isoString)
  return date.toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  if (hours > 0 && mins > 0) {
    return `${hours}h ${mins}m`
  } else if (hours > 0) {
    return `${hours}h`
  } else {
    return `${mins}m`
  }
}

export interface WebinarType {
  id: string
  webinarId: string
  name: string
  nickname: string
  accessLevel: string
  description: string
  schedule: string
  registrationUrl?: string
}

export interface WebinarSessionsResponse {
  status: number
  sessions?: WebinarSession[]
  message?: string
  allWebinarTypes?: WebinarType[]
  accessibleWebinarTypes?: string[]
}

export const getWebinarIdFromNickname = (
  nickname: string,
  allWebinarTypes: WebinarType[]
): string => {
  const webinarType = allWebinarTypes.find((type) => type.nickname === nickname)
  return webinarType?.webinarId || webinarType?.id || ''
}

export const getRegistrationUrlFromNickname = (
  nickname: string,
  allWebinarTypes: WebinarType[]
): string | undefined => {
  const webinarType = allWebinarTypes.find((type) => type.nickname === nickname)
  return webinarType?.registrationUrl
}
